import React from 'react';

import { Container } from './styles';

const Dashboard: React.FC = () => {
  return <Container />;
};

export default Dashboard;
